//@format
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/style.css';
import ErrorBoundary from './components/ErrorBoundary';

// Import Sentry lazily
import('./utils/sentry');


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary fallback='There was an Error'>
    <App />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
